import React, {useState} from "react";
import {Box, Heading, Pagination, Table} from "react-bulma-components";
import SalesPrepRow from "./SalesPrepRow";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";



export default function SalesPrepVehicles({endpoint, data, filters, setFilters}){

  const filter = (vehicle) =>{
    return vehicle.sales_prep
  }

  const headings = [
      {
          label: "Department",
          field: "department",
          labelField: "department__name"
      },
      {
          label: "Registration"
      },
      {
          label: "Make"
      },
      {
          label: "Model"
      },
      {
          label: "Location"
      }
  ]

  return (
    <Box>
      <Heading size={5}>Sales Prep Vehicles</Heading>
      <Table>
        <thead>
          <tr className={"small-row-black"}>
            {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setFilters(f);
                      }}
                      filters={filters}
                      className={heading.className}
                      thClass={heading.thClass}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                    className={heading.className}
                    thClass={heading.thClass}
                  />
                );
              })}
          </tr>
        </thead>
        <tbody>
          {data.results.filter(filter).map((value, index) => (
            <SalesPrepRow
              key={value.id}
              value={value}
              index={index}
              endpoint={endpoint}
            />
          ))}
        </tbody>
      </Table>
    </Box>
  );

}